export const getLocalTime = (nS) => {
  let date = new Date(parseInt(nS));
  let yy = date.getFullYear();
  let mm = date.getMonth() + 1;
  let dd = date.getDate();
  let hh = date.getHours();
  let minutes = date.getMinutes();
  let seconds = date.getSeconds();
  return [
    `${yy}/${addZero(mm)}/${addZero(dd)}`,
    `${addZero(hh)}:${addZero(minutes)}:${addZero(seconds)}`,
  ];
};

export const addZero = (num) => {
  return num < 10 ? '0' + num : num;
};

export const freeze = (data) => Object.freeze(data);

export const type = (obj) => Object.prototype.toString.call(obj).slice(8, -1);

export const findValue = (data, value) => {
  let res = false;
  function _find(data, value) {
    if (type(data) === 'Object') {
      for (let k in data) {
        _find(data[k], value);
      }
    } else if (type(data) === 'Array') {
      data.forEach((item) => {
        _find(item, value);
      });
    } else {
      if (data === value) {
        res = true;
      }
    }
  }
  _find(data, value);
  return res;
};

export const debounce = (fn, delay = 1000, ...args) => {
  if (typeof fn !== 'function') {
    // 参数类型为函数
    throw new TypeError('fn is not a function');
  }

  let lastFn = null;
  return function (event) {
    if (lastFn) {
      clearTimeout(lastFn);
    }
    lastFn = setTimeout(() => {
      fn.call(this, event, ...args);
    }, delay);
  };
};

export const formatPath = (path) => {
  let map = new Map();
  if (!path) return map;
  for (let key in path) {
    map.set(key, path[key]);
  }
  return map;
};

export const getQueryVariable = (variable) => {
  const query = window.location.href.split('?')[1];
  if (query) {
    const vars = query.split('&');
    for (let i = 0; i < vars.length; i++) {
      const pair = vars[i].split('=');
      if (pair[0] == variable) {
        return pair[1];
      }
    }
  }
  return '';
};

// 分秒毫秒转为毫秒
export const timeToSec = (time) => {
  var min = time[0];
  var sec = time[1];
  var ms = time[2];
  var s = Number(min * 6000) + Number(sec * 1000) + Number(ms);
  return s;
};

/* 时间格式化
 *秒转为分秒毫秒格式
 */
export const timeFomat = (time) => {
  let b = time.toFixed(3);
  b = b.split('.');
  let h = Math.floor(time / 3600);
  let m = Math.floor((time % 3600) / 60);
  let s = Math.floor(time % 60);
  let ms = Number(b[1]);
  m = m >= 10 ? m : '0' + m;
  s = s >= 10 ? s : '0' + s;
  if (ms >= 10 && ms < 100) {
    ms = '0' + ms;
  } else if (ms < 10) {
    ms = '00' + ms;
  } else {
    ms = ms;
  }
  if (h === 0) {
    return m + ':' + s + ':' + ms;
  }
  return h + ':' + m + ':' + s;
};

export const getStorage = (key) => {
  return localStorage.getItem(key);
};
export const setStorage = (key, token) => {
  return localStorage.setItem(key, token);
};
export const removeStorage = (key) => {
  localStorage.removeItem(key);
};

export const clearStorage = () => {
  localStorage.clear();
};


export function getLocalStorge_varguardVisible() {
  try {
    return JSON.parse(localStorage.getItem('varguardVisible_arr')) || [];
  } catch (error) {
    return []
  }
}
export function getLocalStorge_mapLabelVisible() {
  try {
    return localStorage.getItem('mapLabelVisible') || "0";
  } catch (error) {
    return "0"
  }
}
